import "./Services.css";

export default function Services() {
  const data = [
    "Mutfak Tezgahı",
    "Merdiven Kaplama",
    "Mezar Taşı",
    "İç Dekorasyon"
  ];

  return (
    <section className="services">
      <h2>Hizmetlerimiz</h2>

      <div className="cards">
        {data.map((item, i) => (
          <div className="card" key={i}>
            <h3>{item}</h3>
            <p>Profesyonel çözümler</p>
          </div>
        ))}
      </div>
    </section>
  );
}